import { AbstractControl } from "@angular/forms";
import { Injectable } from "@angular/core";
import { UserMasterService } from "../../Services/user-master.service";

@Injectable()
export class UserMasterValidators {
  constructor(private service: UserMasterService) {}

  shouldBeUnique(ac: AbstractControl) {
    // ac will hold each of the form controls
    const userID = ac.get("userID").value;
    const id = ac.get("id").value;

    if (userID != null) {
      this.service.checkForDuplicate(userID, id).subscribe(
        (response) => {
          if (response.length > 0)
            ac.get("userID").setErrors({ isDuplicate: true });
          else ac.get("userID").setErrors(null);
        },
        (error) => {
          ac.get("userID").setErrors(null);
        }
      );
    }
  }
}
